import {graphql} from 'react-relay'

export const query = graphql`
  query AgentParametersQuery($locator: String!) {
    agentRest(agentLocator: $locator) {
      ...AgentParameters_agent
    }
  }
`
